module.exports = __webpack_public_path__ + "static/img/mode_qr_bg_x2.1658926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mode_qr_bg_x2.png
// module id = +DgK
// module chunks = 1